import { APP_ROUTES } from "const";
import { useBackgroundImages } from "hooks";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IOutletAuth } from "types";
// Push notifications via Firebase have been removed during the Supabase migration.
// Retain stubs so dependent components remain functional.

function checkLocations(location: Partial<Location>) {
  const checkedLocation =
    location.pathname === APP_ROUTES.ISSUES ||
    location.pathname === APP_ROUTES.SOLUTION_LIST ||
    location.pathname === APP_ROUTES.ACTION_GROUP_LIST ||
    location.pathname === APP_ROUTES.MOTIVATIONAL_LIST ||
    location.pathname === "/";
  return checkedLocation;
}
///
export function useGetRandomBackgroundImage() {
  const location = useLocation();

  const { data: backgroundImages } = useBackgroundImages({
    refetchOnWindowFocus: false,
  });
  const checkedLocation = checkLocations(location);

  const activeBackgrounds = backgroundImages?.data
    ? backgroundImages.data.filter((item) => item.active ?? true)
    : [];

  const [randomIndex, setRandomIndex] = useState(
    activeBackgrounds.length > 0
      ? Math.floor(Math.random() * activeBackgrounds.length)
      : 0
  );

  useEffect(() => {
    if (checkedLocation && activeBackgrounds.length > 0) {
      setRandomIndex(Math.floor(Math.random() * activeBackgrounds.length));
    }
  }, [location.pathname, checkedLocation, activeBackgrounds.length]);
  return activeBackgrounds[randomIndex];
}

export function usePdfUrl(): [
  string | undefined,
  Dispatch<SetStateAction<string | undefined>>
] {
  const location = useLocation();
  const [pdfUrl, setPdfUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (location.pathname === APP_ROUTES.HANDOUTS) {
      setPdfUrl(location.search.split("=")[1]);
    }
  }, [location.pathname, location.search]);
  return [pdfUrl, setPdfUrl];
}

export function useNotificationToken() {
  return null;
}

export function useCheckNotificationToken(_context: IOutletAuth) {
  // Supabase migration: notifications pending replacement.
}

export function useRegisterServiceWorker() {
  // No-op: Firebase messaging removed.
}
